<template>
  <input
    :value="localValue"
    v-bind="$attrs"
    type="tel"
    class="MileageInput"
    @input="handleInput"
  >
</template>

<script>
/**
 * @module MileageInput
 */
import { formatmileage } from '@/utils/utils'

export default {
  name: 'MileageInput',
  props: {
    value: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    localValue () {
      return this.format(this.value)
    }
  },
  methods: {
    format (value) {
      value = parseInt(value || 0)
      return formatmileage(value)
    },
    handleInput (e) {
      const formatted = this.format(e.target.value)
      if (formatted.length > 6) {
        e.target.value = this.localValue
        return
      }
      e.target.value = formatted
      this.$emit('input', formatted)
    }
  }
}
</script>

<style lang='scss'>
@import '~utils';

.MileageInput {
  .has-error & {
    color: map-get($colors, red)
  }
}

</style>
